import React from 'react'

function Spinner(props) {
  try {
    return (
      <>
          <div className={`${props.isbadgespinner ? 'badge' : 'd-flex justify-content-center align-items-center' } ${props.className ? props.className  : ''}`}>
              <span className={`loaderApplication ${props.isbadgespinner ? 'w-10p h-10p' : ''} ${props.spinnerClassName ? props.spinnerClassName : ''}`}>
              </span>
              {
                props.content ?
                  <span className={`ml-8 ${props.textClassName ? props.textClassName : ''}`}>{props.content || ''}</span>
                  :
                  <></>
              }
          </div>
      </>
    )
  } catch (e) {
    console.log(e)
    return <></>
  }
}

export default Spinner

Spinner.defaultProps =  {
  isbadgespinner : false ,
}